export default [
  {
    name: "Head Forward",
    key: "forwardhead",
    definition: {
      name: "Definition",
      list: ["Head forward tilt refers to that when standing and sitting, the head is at the front side relative to the trunk. It is common among students and office people."]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Long-term desk work Head tilt forward developed from long term desk work.",
        "2. Habitually looking down at the phone。looking down for checking phone is one of the common reason for head tilt forward.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. Dizziness and headache: Leaning head forward may affect the blood circulation of the head, and may cause dizziness and headache, because lack of oxygen in the head due to poor blood flow.',
        '2. Cervical spondylosis: Improper head posture may increase risk of cervical spondylosis due to abnormalities in the soft tissues and bones of the neck.',
        '3. Cardiovascular disease: Improper head posture may affect the blood circulation of the head and endanger the health of the cardiovascular and cerebrovascular.',
      ],
    }
  },
  {
    key: "lateralhead",
    name: "Head Tilt",
    definition: {
      name: "Definition",
      list: ["Head Tilt refers to the abnormal posture that the head excessively inclines to one side when the human body is in a natural standing or sitting posture."]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Habitually use unilateral shoulder and neck muscles ; When sitting or lying down, the neck is mostly unidirectional, causing imbalance of left and right shoulder and neck muscles",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. Chronic muscle ligament strain: Long-term head tilt may cause chronic strain of the posterior cervical ligament and muscle ligament.',
        '2. Cervical spondylosis: Improper head posture may increase risk of cervical spondylosis due to abnormalities in the soft tissues and bones of the neck.',
      ],
    }
  },
  {
    key: "unevenshoulder",
    name: "Uneven Shoulder",
    definition: {
      name: "Definition",
      list: ["Uneven shoulder refers to the condition that the height of the left and right shoulders is inconsistent when a person stands naturally, which is often accompanied by scoliosis"]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Excessive stress on one side: Such as long-term unilateral backpacks or lifting.",
        "2. Long-term imporper sitting posture: such as cross legs, and body leaning forward while seating.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. lumbago: (Uneven Shoulder) Back pain occured due to the unbalanced the muscle strength on the left and right sides of the waist caused by pelvic displacement.',
        '2. Bone spur: Uneven shoulders may cause abnormal cervical spine stress, which may eventually lead to cervical spine degeneration and easy to form spur.',
      ],
    }
  },
  {
    key: "roundedshoulder",
    name: "Rounded Shoulder",
    definition: {
      name: "Definition",
      list: ["The round shoulder refers to the state of shoulders forward and inward when the human body is viewed from the side, most of which are accompanied by hunchback."]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Abnormal posture as bad habit: humpbacked, improper side lying.",
        "2. Unbalanced chest&back muscle strength: Weak pectoralis major relative to back muscles.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. Increased heart burden: Excessive rounded shoulders can strain the diaphragm, causing compression of the aorta and vena cava and increasing the burden on the heart.',
        '2. Oppressed nerves: The muscles around the shoulder and neck are tense. In severe cases, it may cause cervical nerve compression, headaches and numb arms.',
      ],
    }
  },
  {
    name: "Scoliosis",
    key: "scoliosis",
    definition: {
      name: "Definition",
      list: ["Scoliosis refers to abnormal spinal position, which may be found through imaging inspection."]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Excessive stress on one side: Such as long-term unilateral backpacks or lifting.",
        "2. Long-term imporper sitting posture: such as cross legs, and body leaning forward while seating.",
        "3. Congenital factor: Congenital spine ectopic.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. Lumbar disc herniation。',
        '2. lumbago: Back pain occured due to the unbalanced the muscle strength on the left and right sides of the waist caused by pelvic displacement.',
        '3. Uneven leg length。',
      ],
    }
  },
  {
    name: "Uneven Hip",
    key: "unevenhip",
    definition: {
      name: "Definition",
      list: ["Pelvic roll refers to the large difference in the height of the left and right hips, presenting a skewed pelvis. It is often accompanied by abnormal spinal position and uneven shoulders"]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Long-term imporper sitting posture: such as cross legs, and body leaning forward while seating.",
        "2. Natural unequal leg length: Due to congenital long and short legs",
        "3. Imbalanced lower body alignment: For example: one foot has flat feet while the other does not, or the other is not as serve; There are knee hyperextension phenomena on both sides, but in different extent.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. Lumbar disc herniation。',
        '2. Chronic pain: Pelvic tilt may cause waist and leg, shoulder and neck pain',
        '3. Uneven leg length。 ',
      ],
    }
  },
  {
    name: "Bow Leg",
    key: "oleg",
    definition: {
      name: "Definition",
      list: ["When people stand with their feet together and their inner ankles close together, the gap between the inner knees is too large, and the legs are in an “O“ shape." +
        "This kind of leg shape is related to daily posture habits, and the appearance of O-shaped legs in children may also be related to rickets."]
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Imporper sitting posture as bad habit Pelvic tilt and foot inversion.",
        "2. Muscle imbalance Hip external rotation is too tight.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1.  Medial meniscus injury: O-shaped leg changes the force line of the lower limb, and the medial space of the knee joint bears a pressure greater than the normal load, causing damage to the medial meniscus of the knee joint',
        '2. Arthritis: .Severe (O leg) may eventually develop into knee osteoarthritis and degeneration of the joint in the lateral joint space. In severe cases, artificial joint replacement is required',
      ],
    }
  },
  {
    name: "Knock Knees",
    key: "xleg",
    definition: {
      name: "Definition",
      list: ['When the human body stands in a normal posture, the inside of the knees can be pressed tightly, but the inside of the ankles on both sides cannot be pressed tightly, or even the gap is large. The legs show an "X" shape. This type of leg shape is related to daily posture habits and muscle strength imbalance.']
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Imporper sitting posture as bad habit Pelvic tilt and foot inversion.",
        "2. Muscle imbalance Hip external rotation is too tight.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1.  Lateral meniscus injury: The X-leg causes the change of the lower limb force line, and the lateral space of the knee joint bears more pressure than the normal load. May cause damage to the lateral meniscus of the knee joint',
        '2. Arthritis: It may eventually develop into osteoarthritis of the knee joint and degeneration of the joint in the lateral joint space. In severe cases, artificial joint replacement is required',
      ],
    }
  },
  {
    name: "Knee Hyperextension",
    key: "kneehyperextension",
    definition: {
      name: "Definition",
      list: ['Knee hyperextension is also called "knee reflexion". From the side view of the human body, it can be seen that the legs are bent to the rear, the knees are concave, and the lower legs are stretched forward excessively compared with the thighs. This posture is common in ballet dancers and those with weak thigh muscles.']
    },
    triggerreason: {
      name: "Reason",
      list: [
        "1. Improper posture when using strength: Majority of weight falls on the forefoot when standing.",
        "2. Plantar fascia tension: May be caused by wearing high heels for a long time.",
        "3. May have weak muscle strength around the knee, inadequate thigh muscles.",
      ]
    },
    danger: {
      name: "Risk",
      list: [
        '1. Knee deformity: Long-term knee hyperextension may increase the risks of bone and joint degeneration, which could lead to excessive tear of the knee joint, and joint deformities.',
        '2. Impaired body balance: The position and function of the three joints of hip, knee and ankle are closely related,' +
        'Changes in the position of the knee joint will affect the position of the ankle joint and the position of the hip joint and pelvis above, gradually damage the balance of the whole body, and will cause various kinds of pain for a long time',
      ],
    }
  },
]